import { motion } from "framer-motion";
import { Hourglass, Images } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const AccessEndingBanner = ({ label }) => {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-6 rounded-3xl bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500 p-5 text-white shadow-xl flex flex-col sm:flex-row sm:items-center gap-4"
      data-testid="access-ending-banner"
    >
      <motion.div animate={{ rotate: [0, 180, 180, 360] }} transition={{ duration: 3, repeat: Infinity }} className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
        <Hourglass className="w-6 h-6" />
      </motion.div>
      <div className="flex-1">
        <p className="font-black text-lg">Akses aplikasi akan berakhir pada {label}</p>
        <p className="text-sm text-white/90 mt-0.5">
          Sesi anak anda di Destiny Junior telah/akan tamat. Sila muat turun gambar kenangan dari Album Koleksi sebelum tarikh tersebut.
        </p>
      </div>
      <button
        onClick={() => navigate("/album")}
        className="shrink-0 inline-flex items-center gap-2 rounded-2xl bg-white text-purple-600 font-black px-4 py-2.5 hover:bg-purple-50 transition-colors"
        data-testid="access-ending-album-btn"
      >
        <Images className="w-4 h-4" /> Album Koleksi
      </button>
    </motion.div>
  );
};
